import { jsxs as e, jsx as o } from "react/jsx-runtime";
import { useRef as _ } from "react";
import { useTranslation as f } from "react-i18next";
import u from "../LoadingIndicator/index.js";
import g from "./PaginationItems/PaginationItems.js";
const h = "forma-ui__pagination-wrapper__root", v = "forma-ui__pagination-wrapper__nav", w = "forma-ui__pagination-wrapper__noItems", I = "forma-ui__pagination-wrapper__loader", n = {
  root: h,
  nav: v,
  noItems: w,
  loader: I
}, P = ({ children: i, isLoading: a, count: t, onChange: s, ...c }) => {
  const r = _(null), { t: l } = f(), m = (p) => {
    if (s(p), !r.current)
      return;
    const d = r.current.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: d,
      behavior: "smooth"
    });
  };
  return /* @__PURE__ */ e("div", { className: n.root, children: [
    /* @__PURE__ */ e("div", { className: n.content, ref: r, children: [
      i,
      a && /* @__PURE__ */ o("div", { className: n.loader, children: /* @__PURE__ */ o(u, { color: "var(--grey-2)" }) }),
      !a && t === 0 && /* @__PURE__ */ o("div", { className: n.noItems, children: l("uikit:search_nothing_found") })
    ] }),
    /* @__PURE__ */ o("div", { className: n.nav, children: /* @__PURE__ */ o(g, { onChange: m, count: t, ...c }) })
  ] });
};
export {
  P as default
};
